(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8142],{

/***/ 36888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VY": function() { return /* binding */ $69cb30bb0017df05$export$7c6e2c02157bb7d2; },
/* harmony export */   "aV": function() { return /* binding */ $69cb30bb0017df05$export$54c2e3dc7acea9f5; },
/* harmony export */   "fC": function() { return /* binding */ $69cb30bb0017df05$export$be92b6f5f03c0fe9; },
/* harmony export */   "xz": function() { return /* binding */ $69cb30bb0017df05$export$41fb9f06171c75f4; }
/* harmony export */ });
/* unused harmony exports createTabsScope, Tabs, TabsList, TabsTrigger, TabsContent */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_primitive__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76652);
/* harmony import */ var _radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32707);
/* harmony import */ var _radix_ui_react_roving_focus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(863);
/* harmony import */ var _radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43216);
/* harmony import */ var _radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40192);
/* harmony import */ var _radix_ui_react_direction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41931);
/* harmony import */ var _radix_ui_react_use_controllable_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39920);
/* harmony import */ var _radix_ui_react_id__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66195);






















/* -------------------------------------------------------------------------------------------------
 * Tabs
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TABS_NAME = 'Tabs';
const [$69cb30bb0017df05$var$createTabsContext, $69cb30bb0017df05$export$355f5bd209d7b13a] = (0,_radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContextScope */ .b)($69cb30bb0017df05$var$TABS_NAME, [
    _radix_ui_react_roving_focus__WEBPACK_IMPORTED_MODULE_2__/* .createRovingFocusGroupScope */ .Pc
]);
const $69cb30bb0017df05$var$useRovingFocusGroupScope = (0,_radix_ui_react_roving_focus__WEBPACK_IMPORTED_MODULE_2__/* .createRovingFocusGroupScope */ .Pc)();
const [$69cb30bb0017df05$var$TabsProvider, $69cb30bb0017df05$var$useTabsContext] = $69cb30bb0017df05$var$createTabsContext($69cb30bb0017df05$var$TABS_NAME);
const $69cb30bb0017df05$export$b2539bed5023c21c = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: valueProp , onValueChange: onValueChange , defaultValue: defaultValue , orientation: orientation = 'horizontal' , dir: dir , activationMode: activationMode = 'automatic' , ...tabsProps } = props;
    const direction = (0,_radix_ui_react_direction__WEBPACK_IMPORTED_MODULE_3__/* .useDirection */ .gm)(dir);
    const [value, setValue] = (0,_radix_ui_react_use_controllable_state__WEBPACK_IMPORTED_MODULE_4__/* .useControllableState */ .T)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)($69cb30bb0017df05$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0,_radix_ui_react_id__WEBPACK_IMPORTED_MODULE_5__/* .useId */ .M)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode
    }, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_6__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        dir: direction,
        "data-orientation": orientation
    }, tabsProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$b2539bed5023c21c, {
    displayName: $69cb30bb0017df05$var$TABS_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsList
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TAB_LIST_NAME = 'TabsList';
const $69cb30bb0017df05$export$9712d22edc0d78c1 = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , loop: loop = true , ...listProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_roving_focus__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: context.orientation,
        dir: context.dir,
        loop: loop
    }), /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_6__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        role: "tablist",
        "aria-orientation": context.orientation
    }, listProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$9712d22edc0d78c1, {
    displayName: $69cb30bb0017df05$var$TAB_LIST_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsTrigger
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$TRIGGER_NAME = 'TabsTrigger';
const $69cb30bb0017df05$export$8114b9fdfdf9f3ba = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , disabled: disabled = false , ...triggerProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_roving_focus__WEBPACK_IMPORTED_MODULE_2__/* .Item */ .ck, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled,
        active: isSelected
    }), /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_6__/* .Primitive.button */ .WV.button, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        type: "button",
        role: "tab",
        "aria-selected": isSelected,
        "aria-controls": contentId,
        "data-state": isSelected ? 'active' : 'inactive',
        "data-disabled": disabled ? '' : undefined,
        disabled: disabled,
        id: triggerId
    }, triggerProps, {
        ref: forwardedRef,
        onMouseDown: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_8__/* .composeEventHandlers */ .M)(props.onMouseDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
            else // prevent focus to avoid accidental activation
            event.preventDefault();
        }),
        onKeyDown: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_8__/* .composeEventHandlers */ .M)(props.onKeyDown, (event)=>{
            if ([
                ' ',
                'Enter'
            ].includes(event.key)) context.onValueChange(value);
        }),
        onFocus: (0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_8__/* .composeEventHandlers */ .M)(props.onFocus, ()=>{
            // handle "automatic" activation if necessary
            // ie. activate tab following focus
            const isAutomaticActivation = context.activationMode !== 'manual';
            if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
        })
    })));
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$8114b9fdfdf9f3ba, {
    displayName: $69cb30bb0017df05$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsContent
 * -----------------------------------------------------------------------------------------------*/ const $69cb30bb0017df05$var$CONTENT_NAME = 'TabsContent';
const $69cb30bb0017df05$export$bd905d70e8fd2ebb = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , forceMount: forceMount , children: children , ...contentProps } = props;
    const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
    const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(isSelected);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false
        );
        return ()=>cancelAnimationFrame(rAF)
        ;
    }, []);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_9__/* .Presence */ .z, {
        present: forceMount || isSelected
    }, ({ present: present  })=>/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_6__/* .Primitive.div */ .WV.div, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            "data-state": isSelected ? 'active' : 'inactive',
            "data-orientation": context.orientation,
            role: "tabpanel",
            "aria-labelledby": triggerId,
            hidden: !present,
            id: contentId,
            tabIndex: 0
        }, contentProps, {
            ref: forwardedRef,
            style: {
                ...props.style,
                animationDuration: isMountAnimationPreventedRef.current ? '0s' : undefined
            }
        }), present && children)
    );
});
/*#__PURE__*/ Object.assign($69cb30bb0017df05$export$bd905d70e8fd2ebb, {
    displayName: $69cb30bb0017df05$var$CONTENT_NAME
});
/* ---------------------------------------------------------------------------------------------- */ function $69cb30bb0017df05$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $69cb30bb0017df05$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
const $69cb30bb0017df05$export$be92b6f5f03c0fe9 = $69cb30bb0017df05$export$b2539bed5023c21c;
const $69cb30bb0017df05$export$54c2e3dc7acea9f5 = $69cb30bb0017df05$export$9712d22edc0d78c1;
const $69cb30bb0017df05$export$41fb9f06171c75f4 = $69cb30bb0017df05$export$8114b9fdfdf9f3ba;
const $69cb30bb0017df05$export$7c6e2c02157bb7d2 = $69cb30bb0017df05$export$bd905d70e8fd2ebb;





//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 62812:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chain]/asset/[assetId]",
      function () {
        return __webpack_require__(9293);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _assetId_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(99603);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-tabs/dist/index.module.js
var index_module = __webpack_require__(36888);
// EXTERNAL MODULE: ./node_modules/@reservoir0x/reservoir-kit-ui/dist/index.mjs + 23 modules
var dist = __webpack_require__(17175);
// EXTERNAL MODULE: ./components/primitives/index.ts + 10 modules
var primitives = __webpack_require__(30758);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-collapsible/dist/index.mjs + 10 modules
var react_collapsible_dist = __webpack_require__(49665);
// EXTERNAL MODULE: ./components/primitives/Collapsible.tsx
var Collapsible = __webpack_require__(61194);
;// CONCATENATED MODULE: ./components/token/ActivityFilters.tsx






const ActivityFilters = (param)=>{
    let { open , setOpen , activityTypes , activityNames , setActivityTypes , setActivityNames  } = param;
    const filters = [
        {
            type: "sale",
            name: "Sales",
            icon: free_solid_svg_icons/* faShoppingCart */.sq$
        },
        {
            type: "ask",
            name: "Listings",
            icon: free_solid_svg_icons/* faTag */.LEN
        },
        {
            type: "bid",
            name: "Offers",
            icon: free_solid_svg_icons/* faHand */.ioV
        },
        {
            type: "transfer",
            name: "Transfer",
            icon: free_solid_svg_icons/* faRightLeft */.eRx
        },
        {
            type: "mint",
            name: "Mint",
            icon: free_solid_svg_icons/* faSeedling */.YKZ
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_collapsible_dist/* Root */.fC, {
        open: open,
        onOpenChange: setOpen,
        style: {
            transition: "width .5s",
            width: open ? 320 : 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* CollapsibleContent */.Fw, {
            css: {
                position: "sticky",
                top: 16 + 80,
                height: "max-content",
                overflow: "auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    "& > div:first-of-type": {
                        mt: "$2"
                    }
                },
                children: filters.map((filter)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            mb: "$3",
                            gap: "$3"
                        },
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    color: "$gray11"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: filter.icon,
                                    width: 16,
                                    height: 16
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body1",
                                css: {
                                    flex: 1
                                },
                                children: filter.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Switch */.rs, {
                                    checked: activityTypes === null || activityTypes === void 0 ? void 0 : activityTypes.includes(filter.type),
                                    onCheckedChange: (checked)=>{
                                        if (checked) {
                                            setActivityTypes([
                                                ...activityTypes,
                                                filter.type
                                            ]);
                                            setActivityNames([
                                                ...activityNames,
                                                filter.name
                                            ]);
                                        } else {
                                            setActivityNames(activityNames.filter((item)=>{
                                                return item != filter.name;
                                            }));
                                            setActivityTypes(activityTypes.filter((item)=>{
                                                return item != filter.type;
                                            }));
                                        }
                                    }
                                })
                            })
                        ]
                    }, filter.type);
                })
            })
        })
    }, "hi");
};

// EXTERNAL MODULE: ./components/common/LoadingSpinner.tsx
var LoadingSpinner = __webpack_require__(74431);
// EXTERNAL MODULE: ./components/common/MobileActivityFilters.tsx
var MobileActivityFilters = __webpack_require__(33808);
// EXTERNAL MODULE: ./components/common/OpenSeaVerified.tsx
var OpenSeaVerified = __webpack_require__(44930);
// EXTERNAL MODULE: ./components/Layout.tsx
var Layout = __webpack_require__(51943);
// EXTERNAL MODULE: ./components/primitives/Dropdown.tsx
var Dropdown = __webpack_require__(12623);
// EXTERNAL MODULE: ./components/primitives/Tab.tsx
var Tab = __webpack_require__(53370);
// EXTERNAL MODULE: ./utils/numbers.ts + 1 modules
var numbers = __webpack_require__(23701);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./hooks/index.ts + 7 modules
var hooks = __webpack_require__(79569);
;// CONCATENATED MODULE: ./components/token/AttributeCard.tsx





/* harmony default export */ var AttributeCard = ((param)=>{
    let { attribute , collectionTokenCount , collectionId  } = param;
    const { routePrefix  } = (0,hooks/* useMarketplaceChain */.gw)();
    const attributeTokenCount = (attribute === null || attribute === void 0 ? void 0 : attribute.tokenCount) || 0;
    const totalTokens = collectionTokenCount ? Number(collectionTokenCount) : 0;
    const attributeRarity = (0,numbers/* formatNumber */.uf)(attributeTokenCount / totalTokens * 100, 1);
    const attributeHref = "/".concat(routePrefix, "/collection/").concat(collectionId, "?attributes[").concat(attribute.key, "]=").concat(attribute.value);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: attributeHref,
        style: {
            minWidth: 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            css: {
                background: "$gray2",
                mr: "auto",
                px: "$4",
                py: "$3",
                borderRadius: 8,
                gap: "$1",
                width: "100%",
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    ellipsify: true,
                    children: attribute.key
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    css: {
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                            style: "subtitle1",
                            ellipsify: true,
                            children: attribute.value
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                            amount: attribute.floorAskPrice,
                            logoHeight: 14,
                            textStyle: "subtitle1",
                            maximumFractionDigits: 2
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                            style: "body3",
                            css: {
                                color: "$gray11"
                            },
                            children: [
                                (0,numbers/* formatNumber */.uf)(attribute.tokenCount),
                                " (",
                                attributeRarity,
                                "%) have this"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                            style: "body3",
                            css: {
                                color: "$gray11"
                            },
                            children: "floor"
                        })
                    ]
                })
            ]
        })
    });
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/primitives/Dialog.tsx
var Dialog = __webpack_require__(39114);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dialog/dist/index.mjs + 15 modules
var react_dialog_dist = __webpack_require__(60430);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 167 modules
var motion = __webpack_require__(26718);
;// CONCATENATED MODULE: ./components/token/FullscreenMedia.tsx









const FullscreenMedia = (param)=>{
    let { token  } = param;
    const mediaType = (0,dist/* extractMediaType */.uh)(token === null || token === void 0 ? void 0 : token.token);
    const [open, setOpen] = (0,react.useState)(false);
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
        color: "gray3",
        corners: "circle",
        css: {
            position: "absolute",
            right: 12,
            top: 12
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
            icon: free_solid_svg_icons/* faExpand */.TL5,
            width: 16,
            height: 16
        })
    });
    if (mediaType === "png" || mediaType === "jpeg" || mediaType === "jpg" || mediaType === "gif" || mediaType === null || mediaType === undefined) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dialog_dist/* Root */.fC, {
        modal: true,
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist/* DialogTrigger */.hg, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                children: open ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dialog_dist/* DialogPortal */.PK, {
                    forceMount: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* AnimatedOverlay */.Q3, {
                            style: {
                                position: "fixed",
                                zIndex: 1000,
                                inset: 0,
                                width: "100vw",
                                height: "100vh",
                                backgroundColor: "rgba(0, 0, 0, 0.6)",
                                backdropFilter: "20px",
                                opacity: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist/* DialogClose */.GG, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                    color: "gray3",
                                    corners: "circle",
                                    css: {
                                        position: "absolute",
                                        right: 12,
                                        top: 12
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faCompress */.Qj4,
                                        width: 16,
                                        height: 16
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* AnimatedContent */.hS, {
                            style: {
                                zIndex: 2000,
                                top: "50%",
                                border: "none",
                                borderRadius: 0,
                                background: "none"
                            },
                            forceMount: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                transition: {
                                    type: "spring",
                                    duration: 1
                                },
                                initial: {
                                    opacity: 0,
                                    top: "0%"
                                },
                                animate: {
                                    opacity: 1,
                                    top: "50%"
                                },
                                exit: {
                                    opacity: 0,
                                    top: "0%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    align: "center",
                                    justify: "center",
                                    css: {
                                        flexDirection: "column",
                                        height: "100%",
                                        width: "100%",
                                        maxWidth: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* TokenMedia */.Y1, {
                                        token: token === null || token === void 0 ? void 0 : token.token,
                                        style: {
                                            borderRadius: 0,
                                            width: "100vw",
                                            height: "auto",
                                            padding: "4px"
                                        }
                                    })
                                })
                            })
                        })
                    ]
                }) : null
            })
        ]
    });
    else {
        return null;
    }
};
/* harmony default export */ var token_FullscreenMedia = (FullscreenMedia);

;// CONCATENATED MODULE: ./components/token/PriceData.tsx




const PriceData = (param)=>{
    let { token  } = param;
    var _token_market, _token_market_floorAsk, _token_market_floorAsk_source, _token_market1, _token_market_floorAsk1, _token_market_floorAsk_source1, _token_market2, _token_market_topBid, _token_market_topBid_source, _token_market3, _token_market_topBid1, _token_market_topBid_source1, _token_token, _token_token1, _token_token2, _token_token3, _token_market4, _token_market_floorAsk2, _token_market_floorAsk_price, _token_market_floorAsk_price_amount, _token_market5, _token_market_floorAsk3, _token_market_floorAsk_price1, _token_market_floorAsk_price_currency, _token_market6, _token_market_floorAsk4, _token_market_floorAsk_price2, _token_market_floorAsk_price_currency1, _token_market7, _token_market_floorAsk5, _token_market_floorAsk_price3, _token_market_floorAsk_price_amount1, _token_market8, _token_market_floorAsk6, _token_market_floorAsk_price4, _token_market_floorAsk_price_amount2, _token_market9, _token_market_topBid2, _token_market_topBid_price, _token_market_topBid_price_netAmount, _token_market10, _token_market_topBid3, _token_market_topBid_price1, _token_market_topBid_price_netAmount1, _token_market11, _token_market_topBid4, _token_market_topBid_price2, _token_market_topBid_price_currency, _token_market12, _token_market_topBid5, _token_market_topBid_price3, _token_market_topBid_price_currency1, _token_market13, _token_market_topBid6, _token_market_topBid_price4, _token_market_topBid_price_amount, _token_market14, _token_market_topBid7, _token_market_topBid_price5, _token_market_topBid_price_currency2, _token_market15, _token_market_topBid8, _token_market_topBid_price6, _token_market_topBid_price_currency3, _token_market16, _token_market_topBid9, _token_market_topBid_price7, _token_market_topBid_price_amount1, _token_market17, _token_market_topBid10, _token_market_topBid_price8, _token_market_topBid_price_amount2;
    const { proxyApi  } = (0,hooks/* useMarketplaceChain */.gw)();
    const listSourceName = token === null || token === void 0 ? void 0 : (_token_market = token.market) === null || _token_market === void 0 ? void 0 : (_token_market_floorAsk = _token_market.floorAsk) === null || _token_market_floorAsk === void 0 ? void 0 : (_token_market_floorAsk_source = _token_market_floorAsk.source) === null || _token_market_floorAsk_source === void 0 ? void 0 : _token_market_floorAsk_source.name;
    const listSourceDomain = token === null || token === void 0 ? void 0 : (_token_market1 = token.market) === null || _token_market1 === void 0 ? void 0 : (_token_market_floorAsk1 = _token_market1.floorAsk) === null || _token_market_floorAsk1 === void 0 ? void 0 : (_token_market_floorAsk_source1 = _token_market_floorAsk1.source) === null || _token_market_floorAsk_source1 === void 0 ? void 0 : _token_market_floorAsk_source1.domain;
    const offerSourceName = token === null || token === void 0 ? void 0 : (_token_market2 = token.market) === null || _token_market2 === void 0 ? void 0 : (_token_market_topBid = _token_market2.topBid) === null || _token_market_topBid === void 0 ? void 0 : (_token_market_topBid_source = _token_market_topBid.source) === null || _token_market_topBid_source === void 0 ? void 0 : _token_market_topBid_source.name;
    const offerSourceDomain = token === null || token === void 0 ? void 0 : (_token_market3 = token.market) === null || _token_market3 === void 0 ? void 0 : (_token_market_topBid1 = _token_market3.topBid) === null || _token_market_topBid1 === void 0 ? void 0 : (_token_market_topBid_source1 = _token_market_topBid1.source) === null || _token_market_topBid_source1 === void 0 ? void 0 : _token_market_topBid_source1.domain;
    const listSourceLogo = "".concat(proxyApi, "/redirect/sources/").concat(listSourceDomain || listSourceName, "/logo/v2");
    const offerSourceLogo = "".concat(proxyApi, "/redirect/sources/").concat(offerSourceDomain || offerSourceName, "/logo/v2");
    const listSourceRedirect = "".concat(proxyApi, "/redirect/sources/").concat(listSourceDomain || listSourceName, "/tokens/").concat(token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.tokenId, "/link/v2");
    const offerSourceRedirect = "".concat(proxyApi, "/redirect/sources/").concat(offerSourceDomain || offerSourceName, "/tokens/").concat(token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : _token_token2.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : _token_token3.tokenId, "/link/v2");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        css: {
            gap: "$6",
            pt: "$4",
            pb: "$5"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "start",
                css: {
                    gap: "$1"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "subtitle2",
                        children: "Price"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        css: {
                            flexDirection: "column",
                            "@bp400": {
                                flexDirection: "row",
                                gap: "$2"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                amount: token === null || token === void 0 ? void 0 : (_token_market4 = token.market) === null || _token_market4 === void 0 ? void 0 : (_token_market_floorAsk2 = _token_market4.floorAsk) === null || _token_market_floorAsk2 === void 0 ? void 0 : (_token_market_floorAsk_price = _token_market_floorAsk2.price) === null || _token_market_floorAsk_price === void 0 ? void 0 : (_token_market_floorAsk_price_amount = _token_market_floorAsk_price.amount) === null || _token_market_floorAsk_price_amount === void 0 ? void 0 : _token_market_floorAsk_price_amount.decimal,
                                address: token === null || token === void 0 ? void 0 : (_token_market5 = token.market) === null || _token_market5 === void 0 ? void 0 : (_token_market_floorAsk3 = _token_market5.floorAsk) === null || _token_market_floorAsk3 === void 0 ? void 0 : (_token_market_floorAsk_price1 = _token_market_floorAsk3.price) === null || _token_market_floorAsk_price1 === void 0 ? void 0 : (_token_market_floorAsk_price_currency = _token_market_floorAsk_price1.currency) === null || _token_market_floorAsk_price_currency === void 0 ? void 0 : _token_market_floorAsk_price_currency.contract,
                                decimals: token === null || token === void 0 ? void 0 : (_token_market6 = token.market) === null || _token_market6 === void 0 ? void 0 : (_token_market_floorAsk4 = _token_market6.floorAsk) === null || _token_market_floorAsk4 === void 0 ? void 0 : (_token_market_floorAsk_price2 = _token_market_floorAsk4.price) === null || _token_market_floorAsk_price2 === void 0 ? void 0 : (_token_market_floorAsk_price_currency1 = _token_market_floorAsk_price2.currency) === null || _token_market_floorAsk_price_currency1 === void 0 ? void 0 : _token_market_floorAsk_price_currency1.decimals,
                                textStyle: "h4",
                                logoHeight: 20,
                                maximumFractionDigits: 4
                            }),
                            (token === null || token === void 0 ? void 0 : (_token_market7 = token.market) === null || _token_market7 === void 0 ? void 0 : (_token_market_floorAsk5 = _token_market7.floorAsk) === null || _token_market_floorAsk5 === void 0 ? void 0 : (_token_market_floorAsk_price3 = _token_market_floorAsk5.price) === null || _token_market_floorAsk_price3 === void 0 ? void 0 : (_token_market_floorAsk_price_amount1 = _token_market_floorAsk_price3.amount) === null || _token_market_floorAsk_price_amount1 === void 0 ? void 0 : _token_market_floorAsk_price_amount1.usd) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body3",
                                css: {
                                    color: "$gray11"
                                },
                                ellipsify: true,
                                children: (0,numbers/* formatDollar */.el)(token === null || token === void 0 ? void 0 : (_token_market8 = token.market) === null || _token_market8 === void 0 ? void 0 : (_token_market_floorAsk6 = _token_market8.floorAsk) === null || _token_market_floorAsk6 === void 0 ? void 0 : (_token_market_floorAsk_price4 = _token_market_floorAsk6.price) === null || _token_market_floorAsk_price4 === void 0 ? void 0 : (_token_market_floorAsk_price_amount2 = _token_market_floorAsk_price4.amount) === null || _token_market_floorAsk_price_amount2 === void 0 ? void 0 : _token_market_floorAsk_price_amount2.usd)
                            }) : null
                        ]
                    }),
                    listSourceName && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: listSourceRedirect,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            css: {
                                borderRadius: 4,
                                gap: "$1",
                                width: "max-content"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    width: "20px",
                                    height: "20px",
                                    src: listSourceLogo
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body3",
                                    css: {
                                        color: "$gray11"
                                    },
                                    children: listSourceName
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "start",
                css: {
                    gap: "$1"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "subtitle2",
                        children: "Top Offer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        css: {
                            flexDirection: "column",
                            "@bp400": {
                                flexDirection: "row",
                                gap: "$2"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                side: "top",
                                open: (token === null || token === void 0 ? void 0 : (_token_market9 = token.market) === null || _token_market9 === void 0 ? void 0 : (_token_market_topBid2 = _token_market9.topBid) === null || _token_market_topBid2 === void 0 ? void 0 : (_token_market_topBid_price = _token_market_topBid2.price) === null || _token_market_topBid_price === void 0 ? void 0 : (_token_market_topBid_price_netAmount = _token_market_topBid_price.netAmount) === null || _token_market_topBid_price_netAmount === void 0 ? void 0 : _token_market_topBid_price_netAmount.decimal) ? undefined : false,
                                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    justify: "between",
                                    css: {
                                        gap: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "body3",
                                            children: "Net Amount"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                            amount: token === null || token === void 0 ? void 0 : (_token_market10 = token.market) === null || _token_market10 === void 0 ? void 0 : (_token_market_topBid3 = _token_market10.topBid) === null || _token_market_topBid3 === void 0 ? void 0 : (_token_market_topBid_price1 = _token_market_topBid3.price) === null || _token_market_topBid_price1 === void 0 ? void 0 : (_token_market_topBid_price_netAmount1 = _token_market_topBid_price1.netAmount) === null || _token_market_topBid_price_netAmount1 === void 0 ? void 0 : _token_market_topBid_price_netAmount1.decimal,
                                            address: token === null || token === void 0 ? void 0 : (_token_market11 = token.market) === null || _token_market11 === void 0 ? void 0 : (_token_market_topBid4 = _token_market11.topBid) === null || _token_market_topBid4 === void 0 ? void 0 : (_token_market_topBid_price2 = _token_market_topBid4.price) === null || _token_market_topBid_price2 === void 0 ? void 0 : (_token_market_topBid_price_currency = _token_market_topBid_price2.currency) === null || _token_market_topBid_price_currency === void 0 ? void 0 : _token_market_topBid_price_currency.contract,
                                            decimals: token === null || token === void 0 ? void 0 : (_token_market12 = token.market) === null || _token_market12 === void 0 ? void 0 : (_token_market_topBid5 = _token_market12.topBid) === null || _token_market_topBid5 === void 0 ? void 0 : (_token_market_topBid_price3 = _token_market_topBid5.price) === null || _token_market_topBid_price3 === void 0 ? void 0 : (_token_market_topBid_price_currency1 = _token_market_topBid_price3.currency) === null || _token_market_topBid_price_currency1 === void 0 ? void 0 : _token_market_topBid_price_currency1.decimals,
                                            textStyle: "subtitle3",
                                            logoHeight: 14
                                        })
                                    ]
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                        amount: token === null || token === void 0 ? void 0 : (_token_market13 = token.market) === null || _token_market13 === void 0 ? void 0 : (_token_market_topBid6 = _token_market13.topBid) === null || _token_market_topBid6 === void 0 ? void 0 : (_token_market_topBid_price4 = _token_market_topBid6.price) === null || _token_market_topBid_price4 === void 0 ? void 0 : (_token_market_topBid_price_amount = _token_market_topBid_price4.amount) === null || _token_market_topBid_price_amount === void 0 ? void 0 : _token_market_topBid_price_amount.decimal,
                                        address: token === null || token === void 0 ? void 0 : (_token_market14 = token.market) === null || _token_market14 === void 0 ? void 0 : (_token_market_topBid7 = _token_market14.topBid) === null || _token_market_topBid7 === void 0 ? void 0 : (_token_market_topBid_price5 = _token_market_topBid7.price) === null || _token_market_topBid_price5 === void 0 ? void 0 : (_token_market_topBid_price_currency2 = _token_market_topBid_price5.currency) === null || _token_market_topBid_price_currency2 === void 0 ? void 0 : _token_market_topBid_price_currency2.contract,
                                        decimals: token === null || token === void 0 ? void 0 : (_token_market15 = token.market) === null || _token_market15 === void 0 ? void 0 : (_token_market_topBid8 = _token_market15.topBid) === null || _token_market_topBid8 === void 0 ? void 0 : (_token_market_topBid_price6 = _token_market_topBid8.price) === null || _token_market_topBid_price6 === void 0 ? void 0 : (_token_market_topBid_price_currency3 = _token_market_topBid_price6.currency) === null || _token_market_topBid_price_currency3 === void 0 ? void 0 : _token_market_topBid_price_currency3.decimals,
                                        textStyle: "h4",
                                        logoHeight: 20
                                    })
                                })
                            }),
                            (token === null || token === void 0 ? void 0 : (_token_market16 = token.market) === null || _token_market16 === void 0 ? void 0 : (_token_market_topBid9 = _token_market16.topBid) === null || _token_market_topBid9 === void 0 ? void 0 : (_token_market_topBid_price7 = _token_market_topBid9.price) === null || _token_market_topBid_price7 === void 0 ? void 0 : (_token_market_topBid_price_amount1 = _token_market_topBid_price7.amount) === null || _token_market_topBid_price_amount1 === void 0 ? void 0 : _token_market_topBid_price_amount1.usd) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body3",
                                css: {
                                    color: "$gray11"
                                },
                                ellipsify: true,
                                children: (0,numbers/* formatDollar */.el)(token === null || token === void 0 ? void 0 : (_token_market17 = token.market) === null || _token_market17 === void 0 ? void 0 : (_token_market_topBid10 = _token_market17.topBid) === null || _token_market_topBid10 === void 0 ? void 0 : (_token_market_topBid_price8 = _token_market_topBid10.price) === null || _token_market_topBid_price8 === void 0 ? void 0 : (_token_market_topBid_price_amount2 = _token_market_topBid_price8.amount) === null || _token_market_topBid_price_amount2 === void 0 ? void 0 : _token_market_topBid_price_amount2.usd)
                            }) : null
                        ]
                    }),
                    offerSourceName && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: offerSourceRedirect,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            css: {
                                borderRadius: 4,
                                gap: "$1",
                                width: "max-content"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    width: "20px",
                                    height: "20px",
                                    src: offerSourceLogo
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body3",
                                    css: {
                                        color: "$gray11"
                                    },
                                    children: offerSourceName
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/token/RarityRank.tsx



/* harmony default export */ var RarityRank = ((param)=>{
    let { token , collection , collectionAttributes  } = param;
    var _token_token, _token_token1;
    const rarityRank = token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.rarityRank;
    const tokenCount = collection === null || collection === void 0 ? void 0 : collection.tokenCount;
    const rankPercentile = Math.floor(rarityRank / parseInt(tokenCount) * 100);
    const topPercentile = (percentile)=>{
        if (percentile <= 1) {
            return 1;
        } else if (percentile <= 5) {
            return 5;
        } else if (percentile <= 10) {
            return 10;
        } else if (percentile <= 15) {
            return 15;
        } else if (percentile <= 20) {
            return 20;
        } else if (percentile <= 25) {
            return 25;
        } else if (percentile <= 30) {
            return 30;
        } else if (percentile <= 40) {
            return 40;
        } else if (percentile <= 50) {
            return 50;
        } else return;
    };
    let topPercentileText = rankPercentile <= 50 && "Top ".concat(topPercentile(rankPercentile), "%");
    const rarityEnabledCollection = tokenCount && +tokenCount >= 2 && collectionAttributes && (collectionAttributes === null || collectionAttributes === void 0 ? void 0 : collectionAttributes.length) >= 2;
    if (rarityRank === undefined || rarityRank === null || (token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.kind) === "erc1155" || !rarityEnabledCollection) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            align: "start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "body3",
                    children: topPercentileText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                    style: "body3",
                    ellipsify: true,
                    children: [
                        "Rarity rank:",
                        " ",
                        "".concat((0,numbers/* formatNumber */.uf)(rarityRank), "/\n            ").concat((0,numbers/* formatNumber */.uf)(tokenCount))
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "body3",
                    color: "subtle",
                    children: "By Poprank"
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            align: "center",
            css: {
                background: "$gray2",
                mt: 24,
                mr: "auto",
                px: "$2",
                py: "$1",
                borderRadius: 4,
                gap: "$1",
                cursor: "pointer"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    style: {
                        width: 13,
                        height: 13
                    },
                    src: "/icons/rarity-icon.svg"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    css: {
                        color: "$gray11"
                    },
                    children: "Rank"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    children: [
                        (0,numbers/* formatNumber */.uf)(rarityRank),
                        " "
                    ]
                })
            ]
        })
    });
});

;// CONCATENATED MODULE: ./components/common/OpenSeaButton.tsx



// OpenSea chain slugs for asset URLs. Chains without OpenSea support
// (e.g. Linea, Arbitrum Nova) return null and the button renders nothing.
const OPENSEA_CHAIN_SLUGS = {
    1: "ethereum",
    137: "matic",
    42161: "arbitrum",
    10: "optimism",
    8453: "base",
    7777777: "zora",
    56: "bsc",
    43114: "avalanche"
};
const openseaAssetUrl = (chainId, contract, tokenId)=>{
    const slug = OPENSEA_CHAIN_SLUGS[chainId];
    if (!slug || !contract || !tokenId) return null;
    return "https://opensea.io/assets/".concat(slug, "/").concat(contract, "/").concat(tokenId);
};
// Outbound purchase link — the relaunch browse/portfolio mode has no native
// execution, so buying happens on OpenSea in a new tab.
const OpenSeaButton = (param)=>{
    let { contract , tokenId , buttonCss , buttonProps , label ="Buy on OpenSea"  } = param;
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const url = openseaAssetUrl(marketplaceChain.id, contract, tokenId);
    if (!url) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
            display: "contents"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
            css: buttonCss,
            color: "primary",
            ...buttonProps,
            children: label
        })
    });
};
/* harmony default export */ var common_OpenSeaButton = (OpenSeaButton);

;// CONCATENATED MODULE: ./components/token/TokenActions.tsx



// Browse-only relaunch: native trading is parked, so the only action is the
// outbound OpenSea buy link (hidden on chains OpenSea doesn't support).
const TokenActions = (param)=>{
    let { token , isOwner  } = param;
    var _token_token, _token_token1;
    const buttonCss = {
        width: "100%",
        height: 52,
        justifyContent: "center",
        minWidth: "max-content",
        "@sm": {
            maxWidth: 250
        }
    };
    if (isOwner) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Grid */.rj, {
        align: "center",
        css: {
            gap: "$4",
            gridTemplateColumns: "repeat(1,minmax(0,1fr))",
            width: "100%",
            "@sm": {
                gridTemplateColumns: "repeat(2,minmax(0,1fr))",
                maxWidth: 500
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_OpenSeaButton, {
            contract: token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.contract,
            tokenId: token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.tokenId,
            buttonCss: buttonCss
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/constants/address.js
var address = __webpack_require__(66373);
;// CONCATENATED MODULE: ./components/token/ActivityTable.tsx












const TokenActivityTable = (param)=>{
    let { id , activityTypes  } = param;
    const data = (0,dist/* useTokenActivity */.oG)(id, {
        types: activityTypes
    }, {
        revalidateOnMount: true,
        fallbackData: []
    });
    (0,react.useEffect)(()=>{
        data.mutate();
        return ()=>{
            data.setSize(1);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityTable, {
        data: data
    });
};
const ActivityTable = (param)=>{
    let { data  } = param;
    const loadMoreRef = (0,react.useRef)(null);
    const loadMoreObserver = (0,esm/* useIntersectionObserver */.S1)(loadMoreRef, {});
    const activities = data.data;
    (0,react.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            data.fetchNextPage();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !data.isValidating && !data.isFetchingPage && activities && activities.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/icons/activity-icon.svg",
                        width: 40,
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        children: "No activity yet"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    height: data.isLoading ? "225px" : "450px",
                    overflowY: "auto",
                    width: "100%",
                    pb: "$2",
                    pr: 15
                },
                children: [
                    activities.map((activity, i)=>{
                        if (!activity) return null;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityTableRow, {
                            activity: activity
                        }, "".concat(activity === null || activity === void 0 ? void 0 : activity.txHash, "-").concat(i));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                        ref: loadMoreRef,
                        css: {
                            height: 20
                        }
                    })
                ]
            }),
            data.isValidating && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                align: "center",
                justify: "center",
                css: {
                    py: "$5"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {})
            })
        ]
    });
};
const logos = {
    transfer: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faRightLeft */.eRx,
        width: 16,
        height: 16
    }),
    sale: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faShoppingCart */.sq$,
        width: 16,
        height: 16
    }),
    mint: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faSeedling */.YKZ,
        width: 16,
        height: 16
    }),
    burned: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faTrash */.$aW,
        width: 16,
        height: 16
    }),
    listing_canceled: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faXmark */.g82,
        width: 16,
        height: 16
    }),
    ask_cancel: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faXmark */.g82,
        width: 16,
        height: 16
    }),
    offer_canceled: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faXmark */.g82,
        width: 16,
        height: 16
    }),
    ask: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faTag */.LEN,
        width: 16,
        height: 16
    }),
    bid: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faHand */.ioV,
        width: 16,
        height: 16
    })
};
const activityTypeToDesciptionMap = {
    ask_cancel: "Listing Canceled",
    bid_cancel: "Offer Canceled",
    mint: "Mint",
    ask: "List",
    bid: "Offer",
    transfer: "Transfer",
    sale: "Sale"
};
const activityTypeToDesciption = (activityType)=>{
    return activityTypeToDesciptionMap[activityType] || activityType;
};
const ActivityTableRow = (param)=>{
    let { activity  } = param;
    var _marketplaceChain_blockExplorers, _marketplaceChain_blockExplorers_default, _activity_price_amount, _activity_price_amount1, _activity_price_currency, _activity_order, _activity_order_source, _activity_order1, _activity_order_source1, _activity_order2, _activity_order_source2;
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 700
    });
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const blockExplorerBaseUrl = (marketplaceChain === null || marketplaceChain === void 0 ? void 0 : (_marketplaceChain_blockExplorers = marketplaceChain.blockExplorers) === null || _marketplaceChain_blockExplorers === void 0 ? void 0 : (_marketplaceChain_blockExplorers_default = _marketplaceChain_blockExplorers.default) === null || _marketplaceChain_blockExplorers_default === void 0 ? void 0 : _marketplaceChain_blockExplorers_default.url) || "https://etherscan.io";
    if (!activity) {
        return null;
    }
    let activityDescription = activityTypeToDesciption((activity === null || activity === void 0 ? void 0 : activity.type) || "");
    const { displayName: toDisplayName  } = (0,hooks/* useENSResolver */.Af)(activity === null || activity === void 0 ? void 0 : activity.toAddress);
    const { displayName: fromDisplayName  } = (0,hooks/* useENSResolver */.Af)(activity === null || activity === void 0 ? void 0 : activity.fromAddress);
    if (isSmallDevice) {
        var _activity_price_amount2, _activity_price_amount3, _activity_price_currency1, _activity_order3, _activity_order_source3, _activity_order4, _activity_order_source4, _activity_order5, _activity_order_source5;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
            css: {
                gridTemplateColumns: "0.75fr 1fr"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                    css: {
                        color: "$gray11"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                children: [
                                    activity.type && logos[activity.type],
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle1",
                                        css: {
                                            ml: "$2",
                                            color: "$gray11",
                                            fontSize: "14px"
                                        },
                                        children: activityDescription
                                    })
                                ]
                            }),
                            activity.price && ((_activity_price_amount2 = activity.price.amount) === null || _activity_price_amount2 === void 0 ? void 0 : _activity_price_amount2.decimal) !== 0 && activity.type && activity.type !== "transfer" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                    amount: (_activity_price_amount3 = activity.price.amount) === null || _activity_price_amount3 === void 0 ? void 0 : _activity_price_amount3.decimal,
                                    address: (_activity_price_currency1 = activity.price.currency) === null || _activity_price_currency1 === void 0 ? void 0 : _activity_price_currency1.contract,
                                    logoHeight: 16,
                                    textStyle: "subtitle1",
                                    css: {
                                        mr: "$2",
                                        fontSize: "14px"
                                    }
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "-"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                justify: "end",
                                css: {
                                    gap: "$3"
                                },
                                children: [
                                    !!((_activity_order3 = activity.order) === null || _activity_order3 === void 0 ? void 0 : (_activity_order_source3 = _activity_order3.source) === null || _activity_order_source3 === void 0 ? void 0 : _activity_order_source3.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        width: "20px",
                                        height: "20px",
                                        src: ((_activity_order4 = activity.order) === null || _activity_order4 === void 0 ? void 0 : (_activity_order_source4 = _activity_order4.source) === null || _activity_order_source4 === void 0 ? void 0 : _activity_order_source4.icon) || "",
                                        alt: "".concat((_activity_order5 = activity.order) === null || _activity_order5 === void 0 ? void 0 : (_activity_order_source5 = _activity_order5.source) === null || _activity_order_source5 === void 0 ? void 0 : _activity_order_source5.name, " Source")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle3",
                                        color: "subtle",
                                        children: (0,hooks/* useTimeSince */.vS)(activity === null || activity === void 0 ? void 0 : activity.timestamp)
                                    }),
                                    activity.txHash && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                                        href: "".concat(blockExplorerBaseUrl, "/tx/").concat(activity.txHash),
                                        color: "primary",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons/* faExternalLink */.gJF,
                                            width: 12,
                                            height: 15
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "baseline",
                                justify: "end",
                                css: {
                                    gap: "$3"
                                },
                                children: [
                                    activity.fromAddress && activity.fromAddress !== address/* zeroAddress */.D ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/portfolio/".concat(activity.fromAddress),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle3",
                                            css: {
                                                color: "$primary11",
                                                "&:hover": {
                                                    color: "$primary10"
                                                }
                                            },
                                            children: fromDisplayName
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle3",
                                        css: {
                                            fontSize: "12px",
                                            color: "$gray11"
                                        },
                                        children: "to"
                                    }),
                                    activity.toAddress && activity.toAddress !== address/* zeroAddress */.D ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/portfolio/".concat(activity.toAddress),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle3",
                                            css: {
                                                color: "$primary11",
                                                "&:hover": {
                                                    color: "$primary10"
                                                }
                                            },
                                            children: toDisplayName
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "-"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        }, activity.txHash);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: "1fr 1fr"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    color: "$gray11"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    css: {
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            children: [
                                activity.type && logos[activity.type],
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle2",
                                    css: {
                                        ml: "$2"
                                    },
                                    color: "subtle",
                                    children: activityDescription
                                })
                            ]
                        }),
                        activity.price && ((_activity_price_amount = activity.price.amount) === null || _activity_price_amount === void 0 ? void 0 : _activity_price_amount.decimal) !== 0 && activity.type && activity.type !== "transfer" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                            align: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                amount: (_activity_price_amount1 = activity.price.amount) === null || _activity_price_amount1 === void 0 ? void 0 : _activity_price_amount1.decimal,
                                address: (_activity_price_currency = activity.price.currency) === null || _activity_price_currency === void 0 ? void 0 : _activity_price_currency.contract,
                                logoHeight: 16,
                                textStyle: "subtitle1",
                                css: {
                                    mr: "$2",
                                    fontSize: "14px"
                                }
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "-"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    css: {
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            justify: "end",
                            css: {
                                gap: "$3"
                            },
                            children: [
                                !!((_activity_order = activity.order) === null || _activity_order === void 0 ? void 0 : (_activity_order_source = _activity_order.source) === null || _activity_order_source === void 0 ? void 0 : _activity_order_source.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    width: "20px",
                                    height: "20px",
                                    src: ((_activity_order1 = activity.order) === null || _activity_order1 === void 0 ? void 0 : (_activity_order_source1 = _activity_order1.source) === null || _activity_order_source1 === void 0 ? void 0 : _activity_order_source1.icon) || "",
                                    alt: "".concat((_activity_order2 = activity.order) === null || _activity_order2 === void 0 ? void 0 : (_activity_order_source2 = _activity_order2.source) === null || _activity_order_source2 === void 0 ? void 0 : _activity_order_source2.name, " Source")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body2",
                                    color: "subtle",
                                    children: (0,hooks/* useTimeSince */.vS)(activity === null || activity === void 0 ? void 0 : activity.timestamp)
                                }),
                                activity.txHash && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                                    href: "".concat(blockExplorerBaseUrl, "/tx/").concat(activity.txHash),
                                    color: "primary",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faExternalLink */.gJF,
                                        width: 12,
                                        height: 15
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            justify: "end",
                            css: {
                                gap: "$3"
                            },
                            children: [
                                activity.fromAddress && activity.fromAddress !== address/* zeroAddress */.D ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    style: {
                                        display: "flex"
                                    },
                                    href: "/portfolio/".concat(activity.fromAddress),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        css: {
                                            color: "$primary11",
                                            "&:hover": {
                                                color: "$primary10"
                                            }
                                        },
                                        children: fromDisplayName
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "-"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body2",
                                    color: "subtle",
                                    children: "to"
                                }),
                                activity.toAddress && activity.toAddress !== address/* zeroAddress */.D ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    style: {
                                        display: "flex"
                                    },
                                    href: "/portfolio/".concat(activity.toAddress),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        css: {
                                            color: "$primary11",
                                            "&:hover": {
                                                color: "$primary10"
                                            }
                                        },
                                        children: toDisplayName
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "-"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }, activity.txHash);
};

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(93024);
// EXTERNAL MODULE: ./stitches.config.ts + 2 modules
var stitches_config = __webpack_require__(31139);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var dist_index_module = __webpack_require__(82010);
// EXTERNAL MODULE: ./utils/truncate.ts
var truncate = __webpack_require__(39525);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 127 modules
var react_markdown = __webpack_require__(48329);
// EXTERNAL MODULE: ./utils/titleCase.ts
var titleCase = __webpack_require__(68437);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/optimizeImage.ts
var optimizeImage = __webpack_require__(77497);
;// CONCATENATED MODULE: ./components/token/TokenInfo.tsx















const TokenInfo = (param)=>{
    let { token , collection  } = param;
    var _token_token, _token_token_collection, _marketplaceChain_blockExplorers, _marketplaceChain_blockExplorers1, _token_token1, _token_token2, _token_token3, _token_token_collection1, _token_token4, _token_token5, _token_token6, _collection_royalties, _collection_royalties1;
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const { theme  } = (0,dist_index_module/* useTheme */.F)();
    const [isExpanded, setIsExpanded] = (0,react.useState)(false);
    const descriptionRef = (0,react.useRef)(null);
    const isMounted = (0,hooks/* useMounted */.s4)();
    const router = (0,next_router.useRouter)();
    let chain = (0,titleCase/* default */.Z)(router.query.chain);
    const CollectionAction = (0,stitches_config/* styled */.zo)(primitives/* Flex */.kC, {
        px: "$4",
        py: "$3",
        color: "$gray12",
        background: "$gray3",
        cursor: "pointer",
        transition: "background 0.25s ease-in",
        height: 40,
        alignItems: "center",
        "&:hover": {
            background: "$gray4"
        }
    });
    const collectionImage = (0,react.useMemo)(()=>{
        var _token_token, _token_token_collection;
        return (0,optimizeImage/* default */.Z)((token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : (_token_token_collection = _token_token.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.image) || (collection === null || collection === void 0 ? void 0 : collection.image), 50);
    }, [
        token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : (_token_token_collection = _token_token.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.image,
        collection === null || collection === void 0 ? void 0 : collection.image
    ]);
    const etherscanImage = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: isMounted && theme === "dark" ? "/icons/etherscan-logo-light-circle.svg" : "/icons/etherscan-logo-circle.svg",
        alt: "".concat(((_marketplaceChain_blockExplorers = marketplaceChain.blockExplorers) === null || _marketplaceChain_blockExplorers === void 0 ? void 0 : _marketplaceChain_blockExplorers.default.name) || "Ethereum", " Icon"),
        height: 16,
        width: 16
    });
    const blockExplorerUrl = "".concat((marketplaceChain === null || marketplaceChain === void 0 ? void 0 : (_marketplaceChain_blockExplorers1 = marketplaceChain.blockExplorers) === null || _marketplaceChain_blockExplorers1 === void 0 ? void 0 : _marketplaceChain_blockExplorers1.default.url) || "https://etherscan.io", "/token/").concat(token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.contract, "?a=").concat(token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : _token_token2.tokenId);
    const twitterLink = (collection === null || collection === void 0 ? void 0 : collection.twitterUsername) ? "https://twitter.com/".concat(collection === null || collection === void 0 ? void 0 : collection.twitterUsername) : null;
    const expandedCss = {
        maxWidth: "100%",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 2,
        textOverflow: "ellipsis",
        overflow: "hidden",
        verticalAlign: "top",
        "*": {
            display: "inline"
        }
    };
    let isLongDescription = false;
    if (descriptionRef.current) {
        isLongDescription = descriptionRef.current.offsetHeight > 50;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            css: {
                gap: "$3",
                maxWidth: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        gap: "$2",
                        flex: 1
                    },
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: collectionImage,
                            style: {
                                width: 36,
                                height: 36,
                                borderRadius: 4
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                            style: "h6",
                            ellipsify: true,
                            children: (token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : (_token_token_collection1 = _token_token3.collection) === null || _token_token_collection1 === void 0 ? void 0 : _token_token_collection1.name) || (collection === null || collection === void 0 ? void 0 : collection.name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                            openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : collection.openseaVerificationStatus
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    css: {
                        fontSize: "16px",
                        fontFamily: 400,
                        overflow: "hidden",
                        a: {
                            textDecoration: "underline"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                            direction: "column",
                            css: isExpanded ? undefined : expandedCss,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                ref: descriptionRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                                    linkTarget: "_blank",
                                    children: collection === null || collection === void 0 ? void 0 : collection.description
                                })
                            })
                        }),
                        isLongDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                            color: "ghost",
                            size: "xs",
                            css: {
                                width: "max-content",
                                color: "$primary11",
                                fontWeight: 500,
                                height: 28,
                                minHeight: 28,
                                px: 0
                            },
                            onClick: ()=>{
                                setIsExpanded(!isExpanded);
                            },
                            children: isExpanded ? "read less" : "read more"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        borderRadius: 8,
                        overflow: "hidden",
                        gap: 1,
                        flexShrink: 0,
                        mb: "$3",
                        width: "max-content"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: blockExplorerUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionAction, {
                                children: etherscanImage
                            })
                        }),
                        twitterLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: twitterLink,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionAction, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_brands_svg_icons/* faTwitter */.mdU,
                                    width: 16,
                                    height: 16
                                })
                            })
                        }),
                        (collection === null || collection === void 0 ? void 0 : collection.discordUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: collection.discordUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionAction, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_brands_svg_icons/* faDiscord */.omb,
                                    width: 16,
                                    height: 16
                                })
                            })
                        }),
                        (collection === null || collection === void 0 ? void 0 : collection.externalUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: collection.externalUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionAction, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faGlobe */.g4A,
                                    width: 16,
                                    height: 16
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    css: {
                        width: "100%",
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            justify: "between",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    css: {
                                        color: "$gray11",
                                        fontWeight: "normal"
                                    },
                                    children: "Contract Address"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                                    href: blockExplorerUrl,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    color: "primary",
                                    weight: "medium",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$2"
                                        },
                                        children: [
                                            (0,truncate/* truncateAddress */.F)(token === null || token === void 0 ? void 0 : (_token_token4 = token.token) === null || _token_token4 === void 0 ? void 0 : _token_token4.contract),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faExternalLink */.gJF,
                                                width: 12,
                                                height: 15
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            justify: "between",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    css: {
                                        color: "$gray11",
                                        fontWeight: "normal"
                                    },
                                    children: "Chain"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    children: chain
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            justify: "between",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    css: {
                                        color: "$gray11",
                                        fontWeight: "normal",
                                        whiteSpace: "nowrap",
                                        mr: "$2"
                                    },
                                    children: "Token ID"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    ellipsify: true,
                                    css: {
                                        maxWidth: "100%"
                                    },
                                    children: token === null || token === void 0 ? void 0 : (_token_token5 = token.token) === null || _token_token5 === void 0 ? void 0 : _token_token5.tokenId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            justify: "between",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    css: {
                                        color: "$gray11",
                                        fontWeight: "normal"
                                    },
                                    children: "Token Standard"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    css: {
                                        textTransform: "uppercase"
                                    },
                                    children: token === null || token === void 0 ? void 0 : (_token_token6 = token.token) === null || _token_token6 === void 0 ? void 0 : _token_token6.kind
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            justify: "between",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    css: {
                                        gap: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle1",
                                            css: {
                                                color: "$gray11",
                                                fontWeight: "normal"
                                            },
                                            children: "Creator Royalties"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "body3",
                                                as: "p",
                                                children: "A fee on every order that goes to the collection creator."
                                            }),
                                            style: {
                                                maxWidth: "210px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                css: {
                                                    color: "$gray11"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faInfoCircle */.sqG,
                                                    width: 16,
                                                    height: 16
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    children: [
                                        (collection === null || collection === void 0 ? void 0 : (_collection_royalties = collection.royalties) === null || _collection_royalties === void 0 ? void 0 : _collection_royalties.bps) ? (collection === null || collection === void 0 ? void 0 : (_collection_royalties1 = collection.royalties) === null || _collection_royalties1 === void 0 ? void 0 : _collection_royalties1.bps) * 0.01 : 0,
                                        "%"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./context/ToastContextProvider.tsx + 4 modules
var ToastContextProvider = __webpack_require__(98045);
// EXTERNAL MODULE: ./node_modules/react-jazzicon/dist/index.js
var react_jazzicon_dist = __webpack_require__(44111);
// EXTERNAL MODULE: ./node_modules/react-jazzicon/dist/Jazzicon.js
var Jazzicon = __webpack_require__(35342);
var Jazzicon_default = /*#__PURE__*/__webpack_require__.n(Jazzicon);
// EXTERNAL MODULE: ./utils/fetcher.ts
var fetcher = __webpack_require__(84205);
// EXTERNAL MODULE: ./utils/till.ts
var till = __webpack_require__(94830);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var wagmi_dist = __webpack_require__(38793);
// EXTERNAL MODULE: ./components/Head.tsx
var Head = __webpack_require__(4049);
;// CONCATENATED MODULE: ./pages/[chain]/asset/[assetId].tsx

































const IndexPage = (param)=>{
    let { assetId , ssr  } = param;
    var _ssr_tokens, _ssr_tokens_tokens, _ssr_tokens_tokens_, _ssrToken_attributes, _token_token, _token_token1, _token_token_collection, _token_token2, _token_token3, _token_token4, _token_token5, _token_token6, _token_token7, _token_token8, _token_token9, _token_token10, _token_token_collection1, _token_token11, _token_token12, _token_token13, _token_token_attributes, _token_token14, _token_token_collection2, _token_token15, _token_token_collection3, _token_token16, _token_token17, _token_token_attributes1, _token_token18;
    const assetIdPieces = assetId ? assetId.toString().split(":") : [];
    let collectionId = assetIdPieces[0];
    const id = assetIdPieces[1];
    const router = (0,next_router.useRouter)();
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const account = (0,wagmi_dist/* useAccount */.mA)();
    const isMounted = (0,hooks/* useMounted */.s4)();
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 900
    }) && isMounted;
    const [tabValue, setTabValue] = (0,react.useState)("info");
    const [isRefreshing, setIsRefreshing] = (0,react.useState)(false);
    const [activityFiltersOpen, setActivityFiltersOpen] = (0,react.useState)(true);
    const [activityTypes, setActivityTypes] = (0,react.useState)([]);
    const [activityNames, setActivityNames] = (0,react.useState)([]);
    const { proxyApi  } = (0,hooks/* useMarketplaceChain */.gw)();
    const contract = collectionId ? collectionId === null || collectionId === void 0 ? void 0 : collectionId.split(":")[0] : undefined;
    const { data: tokens , mutate  } = (0,dist/* useDynamicTokens */.XN)({
        tokens: [
            "".concat(contract, ":").concat(id)
        ],
        includeAttributes: true,
        includeTopBid: true,
        includeQuantity: true
    }, {
        fallbackData: [
            ssr.tokens ? ssr.tokens : {}
        ]
    });
    const token = tokens && tokens[0] ? tokens[0] : undefined;
    // The client-side refetch can return a token without attributes, wiping the
    // SSR on-chain fallback. Restore SSR attributes if the client dropped them.
    const ssrToken = ssr === null || ssr === void 0 ? void 0 : (_ssr_tokens = ssr.tokens) === null || _ssr_tokens === void 0 ? void 0 : (_ssr_tokens_tokens = _ssr_tokens.tokens) === null || _ssr_tokens_tokens === void 0 ? void 0 : (_ssr_tokens_tokens_ = _ssr_tokens_tokens[0]) === null || _ssr_tokens_tokens_ === void 0 ? void 0 : _ssr_tokens_tokens_.token;
    if ((token === null || token === void 0 ? void 0 : token.token) && (!token.token.attributes || token.token.attributes.length === 0) && (ssrToken === null || ssrToken === void 0 ? void 0 : (_ssrToken_attributes = ssrToken.attributes) === null || _ssrToken_attributes === void 0 ? void 0 : _ssrToken_attributes.length) > 0) {
        token.token.attributes = ssrToken.attributes;
    }
    const is1155 = (token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.kind) === "erc1155";
    const { data: collections  } = (0,dist/* useCollections */.bX)({
        id: token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : (_token_token_collection = _token_token1.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.id
    }, {
        fallbackData: [
            ssr.collection ? ssr.collection : {}
        ]
    });
    const collection = collections && collections[0] ? collections[0] : null;
    const { data: userTokens  } = (0,dist/* useUserTokens */.Vy)(is1155 ? account.address : undefined, {
        tokens: [
            "".concat(contract, ":").concat(id)
        ],
        limit: 20
    });
    const attributesData = (0,dist/* useAttributes */.Ch)(collectionId);
    let countOwned = 0;
    if (is1155) {
        var _userTokens_, _userTokens__ownership;
        countOwned = Number((userTokens === null || userTokens === void 0 ? void 0 : (_userTokens_ = userTokens[0]) === null || _userTokens_ === void 0 ? void 0 : (_userTokens__ownership = _userTokens_.ownership) === null || _userTokens__ownership === void 0 ? void 0 : _userTokens__ownership.tokenCount) || 0);
    } else {
        var _token_token19, _token_token_owner, _account_address;
        countOwned = (token === null || token === void 0 ? void 0 : (_token_token19 = token.token) === null || _token_token19 === void 0 ? void 0 : (_token_token_owner = _token_token19.owner) === null || _token_token_owner === void 0 ? void 0 : _token_token_owner.toLowerCase()) === (account === null || account === void 0 ? void 0 : (_account_address = account.address) === null || _account_address === void 0 ? void 0 : _account_address.toLowerCase()) ? 1 : 0;
    }
    const isOwner = countOwned > 0;
    const owner = isOwner ? account === null || account === void 0 ? void 0 : account.address : token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : _token_token2.owner;
    const { displayName: ownerFormatted  } = (0,hooks/* useENSResolver */.Af)(token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : _token_token3.owner);
    const tokenName = "".concat((token === null || token === void 0 ? void 0 : (_token_token4 = token.token) === null || _token_token4 === void 0 ? void 0 : _token_token4.name) || "#".concat(token === null || token === void 0 ? void 0 : (_token_token5 = token.token) === null || _token_token5 === void 0 ? void 0 : _token_token5.tokenId));
    const hasAttributes = (token === null || token === void 0 ? void 0 : (_token_token6 = token.token) === null || _token_token6 === void 0 ? void 0 : _token_token6.attributes) && (token === null || token === void 0 ? void 0 : (_token_token7 = token.token) === null || _token_token7 === void 0 ? void 0 : _token_token7.attributes.length) > 0;
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
        color: "gray3",
        size: "small",
        css: {
            justifyContent: "space-between",
            width: "336px",
            px: "$2",
            py: "$2"
        },
        children: [
            isSmallDevice ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                style: "body1",
                children: activityNames.map(titleCase/* default */.Z).join(", ") || "All Events"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                css: {
                    color: "$slate10"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: free_solid_svg_icons/* faChevronDown */.ptq,
                    width: 16,
                    height: 16
                })
            })
        ]
    });
    (0,react.useEffect)(()=>{
        let tab = tabValue;
        const hasAttributesTab = isMounted && isSmallDevice && hasAttributes;
        if (hasAttributesTab) {
            tab = "attributes";
        } else {
            tab = "info";
        }
        let deeplinkTab = null;
        if (true) {
            const params = new URL(window.location.href).searchParams;
            deeplinkTab = params.get("tab");
        }
        if (deeplinkTab) {
            switch(deeplinkTab){
                case "attributes":
                    if (hasAttributesTab) {
                        tab = "attributes";
                    }
                    break;
                case "info":
                    tab = "info";
                    break;
                case "activity":
                    tab = "activity";
                    break;
                case "listings":
                    tab = "listings";
                    break;
                case "offers":
                    tab = "offers";
                    break;
            }
        }
        setTabValue(tab);
    }, [
        isSmallDevice
    ]);
    (0,react.useEffect)(()=>{
        const updatedUrl = new URL("".concat(window.location.origin).concat(router.asPath));
        updatedUrl.searchParams.set("tab", tabValue);
        router.replace(updatedUrl, undefined, {
            shallow: true
        });
    }, [
        tabValue
    ]);
    const pageTitle = (token === null || token === void 0 ? void 0 : (_token_token8 = token.token) === null || _token_token8 === void 0 ? void 0 : _token_token8.name) ? token.token.name : "".concat(token === null || token === void 0 ? void 0 : (_token_token9 = token.token) === null || _token_token9 === void 0 ? void 0 : _token_token9.tokenId, " - ").concat(token === null || token === void 0 ? void 0 : (_token_token10 = token.token) === null || _token_token10 === void 0 ? void 0 : (_token_token_collection1 = _token_token10.collection) === null || _token_token_collection1 === void 0 ? void 0 : _token_token_collection1.name);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                ogImage: (token === null || token === void 0 ? void 0 : (_token_token11 = token.token) === null || _token_token11 === void 0 ? void 0 : _token_token11.image) || (collection === null || collection === void 0 ? void 0 : collection.banner),
                title: pageTitle,
                description: collection === null || collection === void 0 ? void 0 : collection.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                justify: "center",
                css: {
                    maxWidth: 1320,
                    mt: 10,
                    pb: 100,
                    marginLeft: "auto",
                    marginRight: "auto",
                    px: "$1",
                    gap: 20,
                    flexDirection: "column",
                    alignItems: "center",
                    "@md": {
                        mt: 48,
                        px: "$3",
                        flexDirection: "row",
                        gap: 40,
                        alignItems: "flex-start"
                    },
                    "@lg": {
                        gap: 80
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            maxWidth: "100%",
                            flex: 1,
                            width: "100%",
                            "@md": {
                                maxWidth: 445
                            },
                            "@lg": {
                                maxWidth: 520
                            },
                            "@xl": {
                                maxWidth: 620
                            },
                            position: "relative",
                            "@sm": {
                                ">button": {
                                    height: 0,
                                    opacity: 0,
                                    transition: "opacity .3s"
                                }
                            },
                            ":hover >button": {
                                opacity: 1,
                                transition: "opacity .3s"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                css: {
                                    backgroundColor: "$gray3",
                                    borderRadius: 8,
                                    button: {
                                        opacity: 1,
                                        color: "#fff",
                                        "& svg, & svg path, & svg circle": {
                                            fill: "#fff",
                                            stroke: "#fff"
                                        }
                                    }
                                },
                                children: [
                                    (()=>{
                                        var _token_token, _token_token1;
                                        const mediaUrl = (token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.media) || "";
                                        const imageUrl = (token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.image) || "";
                                        const isAudio = mediaUrl && mediaUrl !== imageUrl;
                                        if (isAudio) {
                                            var _token_token2, _token_token3;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                css: {
                                                    width: "100%",
                                                    minHeight: isMounted && isSmallDevice ? 300 : 445,
                                                    borderRadius: 8,
                                                    overflow: "hidden",
                                                    backgroundColor: "$gray3",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: 16,
                                                    padding: 24
                                                },
                                                children: [
                                                    (token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : _token_token2.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: token.token.image,
                                                        alt: (token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : _token_token3.name) || "Token image",
                                                        style: {
                                                            width: "100%",
                                                            maxWidth: 400,
                                                            borderRadius: 8
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("audio", {
                                                        controls: true,
                                                        src: mediaUrl,
                                                        style: {
                                                            width: "100%",
                                                            maxWidth: 400
                                                        }
                                                    })
                                                ]
                                            });
                                        }
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* TokenMedia */.Y1, {
                                            token: token === null || token === void 0 ? void 0 : token.token,
                                            videoOptions: {},
                                            imageResolution: "large",
                                            style: {
                                                width: "100%",
                                                height: "auto",
                                                minHeight: isMounted && isSmallDevice ? 300 : 445,
                                                borderRadius: 8,
                                                overflow: "hidden"
                                            },
                                            onRefreshToken: ()=>{
                                                mutate === null || mutate === void 0 ? void 0 : mutate();
                                                addToast === null || addToast === void 0 ? void 0 : addToast({
                                                    title: "Refresh token",
                                                    description: "Request to refresh this token was accepted."
                                                });
                                            }
                                        });
                                    })(),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(token_FullscreenMedia, {
                                        token: token
                                    })
                                ]
                            }),
                            (token === null || token === void 0 ? void 0 : (_token_token12 = token.token) === null || _token_token12 === void 0 ? void 0 : _token_token12.attributes) && !isSmallDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Grid */.rj, {
                                css: {
                                    maxWidth: "100%",
                                    width: "100%",
                                    gridTemplateColumns: "1fr 1fr",
                                    gap: "$3",
                                    mt: 24
                                },
                                children: token === null || token === void 0 ? void 0 : (_token_token13 = token.token) === null || _token_token13 === void 0 ? void 0 : (_token_token_attributes = _token_token13.attributes) === null || _token_token_attributes === void 0 ? void 0 : _token_token_attributes.map((attribute)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(AttributeCard, {
                                        attribute: attribute,
                                        collectionTokenCount: (collection === null || collection === void 0 ? void 0 : collection.tokenCount) || 0,
                                        collectionId: collection === null || collection === void 0 ? void 0 : collection.id
                                    }, "".concat(attribute.key, "-").concat(attribute.value));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            flex: 1,
                            px: "$3",
                            width: "100%",
                            "@md": {
                                px: 0,
                                maxWidth: "60%",
                                overflow: "hidden"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                align: "center",
                                css: {
                                    mb: 20
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            mr: "$2",
                                            gap: "$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/".concat(router.query.chain, "/collection/").concat(token === null || token === void 0 ? void 0 : (_token_token14 = token.token) === null || _token_token14 === void 0 ? void 0 : (_token_token_collection2 = _token_token14.collection) === null || _token_token_collection2 === void 0 ? void 0 : _token_token_collection2.id),
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Anchor */.ee, {
                                                    color: "primary",
                                                    css: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "$2"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: free_solid_svg_icons/* faArrowLeft */.acZ,
                                                            height: 16
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                            css: {
                                                                color: "inherit"
                                                            },
                                                            style: "subtitle1",
                                                            ellipsify: true,
                                                            children: token === null || token === void 0 ? void 0 : (_token_token15 = token.token) === null || _token_token15 === void 0 ? void 0 : (_token_token_collection3 = _token_token15.collection) === null || _token_token_collection3 === void 0 ? void 0 : _token_token_collection3.name
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                                                openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : collection.openseaVerificationStatus
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                        onClick: (e)=>{
                                            if (isRefreshing) {
                                                e.preventDefault();
                                                return;
                                            }
                                            setIsRefreshing(true);
                                            (0,fetcher/* default */.ZP)("".concat(window.location.origin, "/").concat(proxyApi, "/tokens/refresh/v1"), undefined, {
                                                method: "POST",
                                                headers: {
                                                    "Content-Type": "application/json"
                                                },
                                                body: JSON.stringify({
                                                    token: "".concat(contract, ":").concat(id)
                                                })
                                            }).then((param)=>{
                                                let { data , response  } = param;
                                                if (response.status === 200) {
                                                    addToast === null || addToast === void 0 ? void 0 : addToast({
                                                        title: "Refresh token",
                                                        description: "Request to refresh this token was accepted."
                                                    });
                                                } else {
                                                    throw data;
                                                }
                                                setIsRefreshing(false);
                                            }).catch((e)=>{
                                                var _DATE_REGEX_exec;
                                                const ratelimit = (_DATE_REGEX_exec = till/* DATE_REGEX.exec */.n.exec(e === null || e === void 0 ? void 0 : e.message)) === null || _DATE_REGEX_exec === void 0 ? void 0 : _DATE_REGEX_exec[0];
                                                addToast === null || addToast === void 0 ? void 0 : addToast({
                                                    title: "Refresh token failed",
                                                    description: ratelimit ? "This token was recently refreshed. The next available refresh is ".concat((0,till/* timeTill */.x)(ratelimit), ".") : "This token was recently refreshed. Please try again later."
                                                });
                                                setIsRefreshing(false);
                                                throw e;
                                            });
                                        },
                                        disabled: isRefreshing,
                                        color: "gray3",
                                        size: "xs",
                                        css: {
                                            cursor: isRefreshing ? "not-allowed" : "pointer"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                            css: {
                                                animation: isRefreshing ? "".concat(LoadingSpinner/* spin */.O, " 1s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite") : "none"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faRefresh */.QDM,
                                                width: 16,
                                                height: 16
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$2"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "h4",
                                    css: {
                                        wordBreak: "break-all"
                                    },
                                    children: tokenName
                                })
                            }),
                            token && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    is1155 && countOwned > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            mt: "$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                color: "subtle",
                                                css: {
                                                    mr: "$2"
                                                },
                                                children: [
                                                    "You own ",
                                                    countOwned
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/portfolio",
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                                                    color: "primary",
                                                    weight: "normal",
                                                    css: {
                                                        ml: "$1",
                                                        fontSize: 12
                                                    },
                                                    children: "Sell"
                                                })
                                            })
                                        ]
                                    }),
                                    !is1155 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            mt: "$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                color: "subtle",
                                                css: {
                                                    mr: "$2"
                                                },
                                                children: "Owner"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((Jazzicon_default()), {
                                                diameter: 16,
                                                seed: (0,react_jazzicon_dist.jsNumberForAddress)(owner || "")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/portfolio/".concat(owner),
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                                                    color: "primary",
                                                    weight: "normal",
                                                    css: {
                                                        ml: "$1"
                                                    },
                                                    children: isMounted ? ownerFormatted : ""
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RarityRank, {
                                        token: token,
                                        collection: collection,
                                        collectionAttributes: attributesData === null || attributesData === void 0 ? void 0 : attributesData.data
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceData, {
                                        token: token
                                    }),
                                    isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenActions, {
                                        token: token,
                                        isOwner: isOwner
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Root */.fC, {
                                        value: tabValue,
                                        onValueChange: (value)=>setTabValue(value),
                                        style: {
                                            paddingRight: isSmallDevice ? 0 : 15
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab/* TabsList */.dr, {
                                                css: {
                                                    overflowX: isSmallDevice ? "scroll" : "unset"
                                                },
                                                children: [
                                                    isMounted && isSmallDevice && hasAttributes && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                        value: "attributes",
                                                        children: "Attributes"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                        value: "info",
                                                        children: "Info"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                        value: "activity",
                                                        children: "Activity"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "attributes",
                                                children: (token === null || token === void 0 ? void 0 : (_token_token16 = token.token) === null || _token_token16 === void 0 ? void 0 : _token_token16.attributes) && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Grid */.rj, {
                                                    css: {
                                                        gap: "$3",
                                                        mt: 24,
                                                        gridTemplateColumns: "1fr",
                                                        "@sm": {
                                                            gridTemplateColumns: "1fr 1fr"
                                                        }
                                                    },
                                                    children: token === null || token === void 0 ? void 0 : (_token_token17 = token.token) === null || _token_token17 === void 0 ? void 0 : (_token_token_attributes1 = _token_token17.attributes) === null || _token_token_attributes1 === void 0 ? void 0 : _token_token_attributes1.map((attribute)=>{
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(AttributeCard, {
                                                            attribute: attribute,
                                                            collectionTokenCount: (collection === null || collection === void 0 ? void 0 : collection.tokenCount) || 0,
                                                            collectionId: collection === null || collection === void 0 ? void 0 : collection.id
                                                        }, "".concat(attribute.key, "-").concat(attribute.value));
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "info",
                                                children: collection && /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenInfo, {
                                                    token: token,
                                                    collection: collection
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab/* TabsContent */.nU, {
                                                value: "activity",
                                                css: {
                                                    mr: -15
                                                },
                                                children: [
                                                    isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileActivityFilters/* MobileActivityFilters */.r, {
                                                        activityTypes: activityTypes,
                                                        setActivityTypes: setActivityTypes
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Dropdown */.Lt, {
                                                        trigger: trigger,
                                                        contentProps: {
                                                            sideOffset: 8
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityFilters, {
                                                            open: activityFiltersOpen,
                                                            setOpen: setActivityFiltersOpen,
                                                            activityTypes: activityTypes,
                                                            activityNames: activityNames,
                                                            setActivityNames: setActivityNames,
                                                            setActivityTypes: setActivityTypes
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenActivityTable, {
                                                        id: "".concat(contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token18 = token.token) === null || _token_token18 === void 0 ? void 0 : _token_token18.tokenId),
                                                        activityTypes: activityTypes
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _assetId_ = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,7533,5348,8329,1943,4646,9774,2888,179], function() { return __webpack_exec__(62812); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);